import { createAsyncThunk } from '@reduxjs/toolkit';

export const openModalSignature = createAsyncThunk(
  'openModalSignature',
  async (
    data: { currentIndexSignature: number },
    { dispatch, extra, getState }: { dispatch: any; extra: any; getState: any }
  ) => {
    return {
      currentIndexSignature: data.currentIndexSignature,
    };
  }
);

export default openModalSignature;
